import { mapRecordsFromServer } from 'core/mappers';
import { partfinitiClient } from 'core/services';
import { GetManyResponse } from 'core/types';
import { getQueryStringToSnakeCase } from 'core/utils';
import { ICorporatePart } from 'corporate/types';
import { IAttributePartListPayload } from 'parts/types';

export const getPartList = async (
  requestPayload?: IAttributePartListPayload,
  signal?: AbortSignal
): Promise<GetManyResponse<ICorporatePart>> => {
  const { data } = await partfinitiClient.get(
    `/parts/pricing-group-part-list/parts?${getQueryStringToSnakeCase(requestPayload)}`,
    signal
  );

  return mapRecordsFromServer<ICorporatePart>(data?.data, data?.recordsFiltered);
};
